import { STAT_LABELS } from '../data/megaPokemon.js';

const formatValue = (value) => new Intl.NumberFormat('es-CL', { maximumFractionDigits: 1 }).format(value);

export class ProfileDialog {
  constructor(dialog, getVisiblePokemon) {
    this.dialog = dialog;
    this.getVisiblePokemon = getVisiblePokemon;
    this.currentSlug = null;
    this.sequenceTimer = null;

    this.elements = {
      close: dialog.querySelector('[data-close-dialog]'),
      previous: dialog.querySelector('[data-previous-pokemon]'),
      next: dialog.querySelector('[data-next-pokemon]'),
      transformImage: dialog.querySelector('[data-transform-image]'),
      image: dialog.querySelector('[data-profile-image]'),
      number: dialog.querySelector('[data-profile-number]'),
      name: dialog.querySelector('[data-profile-name]'),
      description: dialog.querySelector('[data-profile-description]'),
      types: dialog.querySelector('[data-profile-types]'),
      height: dialog.querySelector('[data-profile-height]'),
      weight: dialog.querySelector('[data-profile-weight]'),
      ability: dialog.querySelector('[data-profile-ability]'),
      stats: dialog.querySelector('[data-profile-stats]'),
    };

    this.bindEvents();
  }

  bindEvents() {
    this.elements.close.addEventListener('click', () => this.close());
    this.elements.previous.addEventListener('click', () => this.navigate(-1));
    this.elements.next.addEventListener('click', () => this.navigate(1));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('close', () => this.reset());
  }

  open(pokemon) {
    this.currentSlug = pokemon.slug;
    this.populate(pokemon);
    if (!this.dialog.open) this.dialog.showModal();
    this.playSequence();
  }

  close() {
    window.clearTimeout(this.sequenceTimer);
    if (this.dialog.open) this.dialog.close();
  }

  reset() {
    this.dialog.classList.remove('is-transforming', 'is-revealed');
    document.documentElement.classList.remove('dialog-open');
  }

  populate(pokemon) {
    const { elements } = this;
    elements.transformImage.src = pokemon.image;
    elements.image.src = pokemon.image;
    elements.image.alt = pokemon.name;
    elements.name.textContent = pokemon.name;
    elements.number.textContent = `#${String(pokemon.number).padStart(4, '0')}`;
    elements.description.textContent = pokemon.description;
    elements.types.innerHTML = pokemon.typeLabels
      .map(
        (label, index) =>
          `<span class="type-pill type-pill--${pokemon.types[index]}">${label}</span>`,
      )
      .join('');
    elements.height.textContent = `${formatValue(pokemon.height)} m`;
    elements.weight.textContent = `${formatValue(pokemon.weight)} kg`;
    elements.ability.textContent = pokemon.ability;
    elements.stats.innerHTML = pokemon.stats
      .map(
        ({ name, value }) => `
          <div class="stat-meter">
            <div><span>${STAT_LABELS[name] ?? name}</span><strong>${value}</strong></div>
            <span class="stat-meter__track">
              <i style="--stat-value: ${Math.min((value / 180) * 100, 100)}%"></i>
            </span>
          </div>
        `,
      )
      .join('');
    this.dialog.style.setProperty('--profile-accent', pokemon.accent);
  }

  playSequence() {
    window.clearTimeout(this.sequenceTimer);
    this.dialog.classList.remove('is-transforming', 'is-revealed');
    document.documentElement.classList.add('dialog-open');
    // Reinicia las animaciones CSS incluso al navegar entre fichas.
    void this.dialog.offsetWidth;
    this.dialog.classList.add('is-transforming');

    const reduced = document.documentElement.classList.contains('reduce-motion');
    this.sequenceTimer = window.setTimeout(
      () => {
        this.dialog.classList.add('is-revealed');
        this.elements.close.focus({ preventScroll: true });
      },
      reduced ? 80 : 2200,
    );
  }

  navigate(direction) {
    const pokemon = this.getVisiblePokemon();
    if (!pokemon.length) return;
    const index = pokemon.findIndex(({ slug }) => slug === this.currentSlug);
    const nextIndex = (index + direction + pokemon.length) % pokemon.length;
    this.currentSlug = pokemon[nextIndex].slug;
    this.populate(pokemon[nextIndex]);
    this.playSequence();
  }
}
